import { Helmet } from "react-helmet-async";

const SITE_NAME = "StreatEat";
const BASE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const DEFAULT_IMAGE = `${BASE_URL}/og-default.jpg`;
const DEFAULT_DESC =
  "StreatEat, l'annuaire n°1 des foodtrucks. Trouvez les meilleurs foodtrucks ouverts près de chez vous en temps réel, leurs emplacements du jour, horaires et avis.";

export const Seo = ({
  title,
  description = DEFAULT_DESC,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd = null,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | L'annuaire n°1 des foodtrucks`;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow" />}
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
